'use client'

import type { PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import { SceneID } from '@/enums/agent'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/**
 * Gemini Omni Flash 页面布局客户端组件
 * 使用公共的 SpaceLayoutClient，配置 basePath 为 /omni-flash，默认模型为 OMNI（可切换其他模型）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/omni-flash', defaultModelId: SceneID.OMNI }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
